import { AnnotationIcon, SpeakerphoneIcon, ThumbUpIcon } from '@heroicons/react/outline'
import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-300">
        Guess the BTS song of the day in 7 tries.
      </p>

      <div className="flex justify-center mb-1 mt-4 px-4">
        <SpeakerphoneIcon className="h-7 w-7 text-white mr-2" aria-hidden="true"/>
        <p className="text-sm text-gray-300">
          For your first guess, you can only use the lyrics as your hint.
        </p>
      </div>

      <div className="flex justify-center mb-1 mt-4 px-4">
        <SpeakerphoneIcon className="h-7 w-7 text-white mr-2" aria-hidden="true"/>
        <p className="text-sm text-gray-300">
          After the first guess, you can start listening to the snippet.
        </p>
      </div>

      <div className="flex justify-center mb-1 mt-4 px-4">
        <AnnotationIcon className="h-7 w-7 text-white mr-2" aria-hidden="true"/>
        <p className="text-sm text-gray-300">
          Skipped or incorrect attempts unlock more of the snippet.
        </p>
      </div>

      <div className="flex justify-center mb-1 mt-4 px-4">
        <ThumbUpIcon className="h-7 w-7 text-white mr-2" aria-hidden="true"/>
        <p className="text-sm text-gray-300">
          Answer in as few tries as possible and share your score!
        </p>
      </div>

      <div className="relative flex py-5 items-center">
        <div className="flex-grow border-t border-gray-400"></div>
        <span className="flex-shrink mx-4 text-gray-400">About this game</span>
        <div className="flex-grow border-t border-gray-400"></div>
      </div>
      <p className="text-sm text-gray-500 text-gray-300">
        This game is inspired by the original Heardle and created by         <a
          href="https://twitter.com/btsheardle"
          className="underline font-bold"
        >
          BTSCHARTDATA
        </a><br></br>Like the game?  <a
          href="https://ko-fi.com/btschartdata"
          className="underline font-bold"
        >Support us via Ko-fi</a><br></br>
        Lyrics and translations by <a className="underline font-bold" href="https://doolsetbangtan.wordpress.com/">doolsetbangtan</a>,  <a className="underline font-bold" href="https://www.bangtansubs.com/lyrics/">BTS Trans</a>, btsdiary
      </p>

      <button className="rounded-lg p-2 px-5 bg-violet-500 text-white font-bold mt-4" onClick={handleClose}>Play</button>
    </BaseModal>
  )
}
